module.exports = __webpack_public_path__ + "img/dip-icon3.ed27a439.svg";